<template>
  <div class="features-slider d-flex">
    <div class="slider-bullets">
      <ul class="numbered-steps">
        <li :class="{active: slide === 1}" @click="switchSlide(1)">
          <div>
            <span>Insurance</span>
            <strong>1</strong>
          </div>
        </li>
        <li :class="{active: slide === 2}" @click="switchSlide(2)">
          <div>
            <span>POS Terminal</span>
            <strong>2</strong>
          </div>
        </li>
        <li :class="{active: slide === 3}" @click="switchSlide(3)">
          <div>
            <span>Mastercard</span>
            <strong>3</strong>
          </div>
        </li>
        <li :class="{active: slide === 4}" @click="switchSlide(4)">
          <div>
            <span>Lending</span>
            <strong>4</strong>
          </div>
        </li>
        <li :class="{active: slide === 5}" @click="switchSlide(5)">
          <div>
            <span>Hot customer</span>
            <strong>5</strong>
          </div>
        </li>
      </ul>
    </div>
    <div class="slider-slides d-flex align-items-center">
      <transition name="scale-fade" mode="out-in">
        <div class="slide" v-if="slide === 1" :key="'slide1'">
          <h5 class="white">
            Online
            <span class="primary-color">shop insurance</span>
            features on the go
          </h5>
          <p class="lighter-gray mb-0">
            More security for more success
            in online trading, comprehensive insurance
            protection with discounted conditions
            only for kopplr customers
          </p>
        </div>
        <div class="slide" v-if="slide === 2" :key="'slide2'">
          <h5 class="white">
            Accepting
            <span class="primary-color">payments</span>
            at your point of sale
          </h5>
          <p class="lighter-gray mb-0">
            Ykopplr POS is the smallest desktop
            payment terminal and has all required
            payment industry certifications and
            delivers the highest levels of payment .
          </p>
        </div>
        <div class="slide" v-if="slide === 3" :key="'slide3'">
          <h5 class="white">
            <span class="primary-color">Banking</span> suite and
            prepaid mastercard
          </h5>
          <p class="lighter-gray mb-0">
            Focus on your business - kopplr simplifies
            the handling of international money
            transfers and payments. Our solutions are
            specifically designed for real time handling.
          </p>
        </div>
        <div class="slide" v-if="slide === 4" :key="'slide4'">
          <h5 class="white">
            Grow your business
            with
            <span class="primary-color">merchant lending</span>
          </h5>
          <p class="lighter-gray mb-0">
            koppl offers also merchant lending, by using
            a cash advance program which is indivdually
            customizable and fits to the merchants
            needs and capabilities.
          </p>
        </div>
        <div class="slide" v-if="slide === 5" :key="'slide5'">
          <h5 class="white">
            Customized marketing with
            <span class="primary-color">hot customer</span>
          </h5>
          <p class="lighter-gray mb-0">
            With an AI backend, kopplr triggers
            your marketing events based on data
            enriching from transactions, which
            brings the shop message to a customer.
          </p>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'features-slider',
  computed: {
    ...mapFields({
      slide: 'ui.slideNumber'
    })
  },
  methods: {
    switchSlide(i) {
      this.$store.commit('changeFeatureSlide', i)
    }
  }
}
</script>
